
var React = require("react");

class Button extends React.Component  {

    render(){
        let { 
            disabled = false, 
            removeDisable = false, 
            reasonDisabled = '', 
            tooltip = '', 
            tooltipPos = '', 
            className, 
            onClick
        } = this.props;

        const Tooltip = () => {
            if(disabled && reasonDisabled !== ''){
                return <span className={`tooltip ${tooltipPos}`}>{reasonDisabled}</span>
            }
            if(tooltip){
                return <span className={`tooltip ${tooltipPos}`}>{tooltip}</span>
            }else{
                return null
            }
        }

        if(disabled === true) onClick = null;
        return (!removeDisable &&
                        <React.Fragment>
                            <button disabled={disabled} className={className} onClick={onClick} >
                                {this.props.children}
                            </button>
                            <Tooltip/>
                        </React.Fragment>)
    }
}

module.exports = Button;